import api from '@/services/Api';

class GuaranteeExtensionBoomerangService {
  async getExtensionBySerialNumberAndProductBoomerangId(serialNumber, productBoomerangId) {
    let encodedProductBoomerangId = encodeURIComponent(productBoomerangId)

    const response = await api.get(
      '/distributor/guarantee-extension-boomerang/' + serialNumber + '/by-product-id/' + encodedProductBoomerangId)
    return response.data
  }

}

export default new GuaranteeExtensionBoomerangService()
